import React from 'react';
import moment from 'moment';

import { SearchTextField, MCButton, SelectField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { TableLibrary } from 'src/components/complex';
import TreatmentDetail from 'src/components/treatments/TreatmentDetail';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import {
  remCss,
  userFullName,
  lang,
  scssVariables as variables,
  withRouter,
  objectToSelectList,
  permissions
} from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';
import ShortInfo from '../../../../components/user/ShortInfo';

class Treatments extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    if (!model.initFlag) {
      model.refresh();
      model.initFlag = true;
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();
    let { openId, user } = model.state;

    const columns = [
      {
        label: LANG_CONST.clients,
        resize: true,
        renderCell: (item) => {
          const patient = item.patient || {};
          return <ShortInfo user={patient} specialist={[]} to={permissions.profilePath(patient)} />;
        }
      },
      {
        label: LANG_CONST.diagnosis,
        resize: true,
        renderCell: (item) => item.data?.diagnosis
      },
      {
        label: LANG_CONST.date,
        resize: true,
        renderCell: (item) => moment(item.date).format('DD - MMMM - YYYY')
      },
      {
        label: LANG_CONST.location,
        resize: true,
        renderCell: (item) => (item.clinic?.id ? userFullName(item.clinic) : '')
      },
      {
        label: LANG_CONST.doctors,
        resize: true,
        renderCell: (item) => {
          const doctor = item.doctor || {};
          return <ShortInfo user={doctor} to={permissions.profilePath(doctor)} />;
        }
      },
      {
        label: LANG_CONST.status,
        resize: true,
        renderCell: (item) =>
          item.data.feedback?.status && (
            <button className={'mc-status-' + item.data.feedback?.status}>
              {lang.t(LANG_CONST.constants.health_statuses[item.data.feedback?.status])}
            </button>
          )
      },
      {
        label: LANG_CONST.actions,
        cellStyles: { textAlign: 'end' },
        width: `${remCss(100)}px`,
        renderCell: (item) => (
          <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
            <MCButton
              onClick={() => model.setState({ openId: openId === item.id ? null : item.id })}
              tiny
              quaternary
              light
              radius
            >
              <span
                className={'mc-rotate ' + (openId === item.id ? 'mc-rotate-180' : '')}
                style={{ height: remCss(42) }}
              >
                <SVGIcon
                  iconname={BASE_ICONS.DOWN}
                  width={42}
                  padding={7}
                  fill={variables['colors-mc-orange']}
                />
              </span>
            </MCButton>
          </div>
        )
      }
    ].filter((c) => !!c);

    return (
      <div className={'mc-container-content'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.treatments)}</span>
          <SearchTextField
            width={300}
            template={'2'}
            onChange={(text) => {
              model.setStateSilent({
                pageIndex: 0
              });
              model.setListStateSilent({ items: [], total: 0 }, 'search');
              model.handleChangeSearch(text);
              if (!text) {
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.refresh();
              }
            }}
            value={model.listInput('search')}
          />
          <SelectField
            width={remCss(150)}
            isClearable={false}
            style={{ zIndex: 3 }}
            template={'6'}
            options={[
              { value: 'all', label: lang.t(LANG_CONST.all) },
              ...objectToSelectList(LANG_CONST.constants.health_statuses)
            ]}
            name={'status'}
            placeholder={'Health'}
            value={model.input('status')}
            onChange={(n, v) => {
              if (v.toString() === model.input('status').toString()) return;
              model.setStateSilent({
                pageIndex: 0,
                status: v
              });
              model.setListState({ items: [], total: 0 }, model.getCurrentId(), null, true);
              model.refresh();
            }}
          />
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
            <TableLibrary
              renderExtend={(item) =>
                openId === item.id && (
                  <TreatmentDetail
                    item={item}
                    auth={user}
                    onSeeMore={() =>
                      this.navigate('/admin/treatments/' + item.id, {
                        state: { treatment: item }
                      })
                    }
                  />
                )
              }
              columns={columns}
              data={items}
              loading={loading}
              noResults={noResults}
              searchQuery={searchQuery}
              sortBy={model.state.sortBy}
              selectedPage={model.state.pageIndex}
              total={total}
              limit={model.listLimit}
              onSortChange={(sortBy) => {
                model.handleChange('sortBy', sortBy);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              onSetPage={(v) => {
                model.handleChange('pageIndex', v);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Treatments);
